(function ($, Drupal, window, document) {
  'use strict';

  // Example of Drupal behavior loaded.
  Drupal.behaviors.directoryMA = {
    attach: function directoryMA(context, settings) {
      if (typeof context['location'] !== 'undefined') { // Only fire on document load.

        function directoryExpand() {
          $('.directory__row').on('click touchend', function (e) {
            if ($(window).width() < 1024) {
              e.preventDefault();
              $(this).children('.directory__headings').toggleClass('open');
              $(this).children('.directory__info').toggle();
            } else {
              $('directory__headings, directory__info').css('display', '').removeClass('open');
            }
          });
        }

        directoryExpand();

        // Debounce screen resize event
        var debounce;
        window.addEventListener('resize', function () {
          clearTimeout(debounce);
          debounce = setTimeout(directoryExpand, 100);
        });
      }
    }
  };

})(jQuery, Drupal, window, document);
